import { Content, Device, Group } from '.';

enum ROLE {
  GUEST = 0,
  CONTENT_MANAGER = 1,
  DEVICE_MANAGER = 2,
  ADMINISTRATOR = 3,
}
export interface UserUsage {
  enabled: boolean;
  // spaceGB?: number,
  diskQuotaGb?: number;
  message?: string;
  usedBytes: number;
  usedPerc?: number;
}

export class User {
  public static ROLE = ROLE;
  public _id: string;

  public createdAt: number;
  public updatedAt: number;
  public lastLogin: number;
  public username: string;
  public password: string;
  public avatar: string;
  public name: string;
  public type: number;
  public group: any;
  public myDevices: Device[];
  public myContents?: Content[];
  public country: string;
  public project: string;
  public email: string;
  public diskQuotaGb: number;
  public quota?: UserUsage;

  public devicesOwned: any;
  public numdevices: any;
  public devices: any;
}
